  $(document).ready(function() {
    $('.wa-label-name').click(function(e) {
        e.preventDefault();
        $(this).parent('.wa-label').toggleClass('open');
        $(this).siblings('.wa-label-description').toggleClass('open');
    });
});


$(document).ready(function(){
  $(".owl-carousel").owlCarousel();
});

$('.wa-review-owl-craousel').owlCarousel({
    margin: 50,
    loop: true,
    nav: false,
    dots: false,
    responsive: {
        1300: {
            items: 3,
        },
        1050: {
            items: 3,
        },
      650: {
            items:2,
        },
        0: {
            items: 1,
        }
    },
});

$('.wa-owl-brands').owlCarousel({
    margin: 20,
    loop: true,
    dots: false,
    responsive: {
        1300: {
            items: 6
        },
        1000: {
            items: 5
        },
        700: {
            items: 4
        },
        500: {
            items: 3
        },
        400: {
            items: 2,
            nav: true
        },
        0: {
            items: 1
        }
    },
});